<template>
  <span v-if="form"
    >{{ condition.mustBe | ififnot }} dynamic form '{{
      form.title.substring(0, 25)
    }}'</span
  >
</template>

<script>

import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({}),
    form() {
      return this.$store.getters["dynamicForms/dynamicForm"](
        this.condition.formId
      );
    },
  },
  async mounted() {
    await this.$store.dispatch("dynamicForms/getAll", false);
  },
};
</script>

<style lang="scss">
</style>